import React from 'react';
import { Link } from 'react-router-dom';

function TermsOfConditions() {
  return (
    <>
      <nav className="flex justify-between items-center px-6 py-4 bg-white shadow-sm fixed top-0 w-full z-50">
        <div className="text-xl font-bold text-primary">
          <Link to="/" className="text-primary no-underline">Remote Assistant</Link>
        </div>
        <div className="flex items-center gap-6">
          <Link to="/" className="text-gray-700 hover:text-primary no-underline">Home</Link>
          <Link to="/signup" className="px-6 py-3 rounded-xl bg-primary hover:bg-primary-hover text-white font-semibold shadow no-underline">
            Get Started
          </Link>
        </div>
      </nav>

      <section className="pt-24 pb-16 px-8 max-w-4xl mx-auto">
        <div className="bg-white p-12 rounded-2xl shadow-sm border">
          <h1 className="text-4xl font-bold text-gray-900 mb-4 text-center">Terms of Conditions</h1>
          <p className="text-center text-gray-600 mb-8">
            <strong>Effective Date:</strong> {new Date().toLocaleDateString()}
          </p>
          
          <div className="text-center mb-12 p-6 bg-gray-50 rounded-xl">
            <a 
              href="/remote_assistant_toc.pdf" 
              download 
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary hover:bg-primary-hover text-white font-semibold shadow no-underline"
            >
              📄 Download PDF Version
            </a>
          </div>

          <div className="space-y-8">
            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing and using Remote Assistant AI services, you accept and agree to be bound by these Terms of Conditions.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">2. Service Description</h2>
              <p className="text-gray-700 leading-relaxed">
                Remote Assistant AI provides AI-powered virtual assistant services including call answering, appointment booking, payment processing, and calendar management.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">3. User Responsibilities</h2>
              <p className="text-gray-700 leading-relaxed">
                You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account. You must provide accurate information and comply with all applicable laws.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">4. Service Availability</h2>
              <p className="text-gray-700 leading-relaxed">
                We strive to provide continuous service but do not guarantee uninterrupted availability. Scheduled maintenance and unforeseen outages may occur.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">5. Payment Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                Subscription fees are billed monthly in advance. All fees are non-refundable except as required by law. We reserve the right to modify pricing with 30 days notice.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">6. Data and Privacy</h2>
              <p className="text-gray-700 leading-relaxed">
                Your use of our services is subject to our Privacy Policy. We process your data to provide services and may use aggregated, anonymized data for service improvement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">7. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Our liability is limited to the amount paid for services in the preceding 12 months. We are not liable for indirect, incidental, or consequential damages.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">8. Termination</h2>
              <p className="text-gray-700 leading-relaxed">
                Either party may terminate this agreement at any time. Upon termination, your access to services will cease and data may be deleted according to our retention policy.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">9. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These terms are governed by the laws of the jurisdiction where Remote Assistant AI is incorporated, without regard to conflict of law principles.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-semibold text-primary mb-4">10. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed">
                For questions about these terms, contact us at <a href="mailto:legal@remote-assistant.ai" className="text-primary hover:underline">legal@remote-assistant.ai</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TermsOfConditions;